import React, { useState } from 'react';
import { SiteSearch } from '@wix/wix-ui-icons-common';
import s from './solution-overview.scss';
import { biLogger } from '../../../../bi';
import type { IOverViewProps } from './solution-overview';
import { DescriptionBenefits } from './description-benefits';
import {
  DescriptionPreviewWrapper,
  DemoLinkPreviewWrapper,
} from '../../preview-elements';
import {
  Text,
  Heading,
  TextButton,
  Card,
  Divider,
  Box,
} from '@wix/design-system';
import { VisibilityDetector } from '@wix/app-market-components';
import { appMarketDemoLinkClicked } from '@wix/bi-logger-market/v2';
import { isValidUrl } from '../../../../common/url-validation';

const SolutionDescription = ({
  solutionDemo,
  t,
  description,
  name,
  benefits,
  appId,
  biData,
}: IOverViewProps) => {
  const [isBodyExpanded, updateIsBodyExpanded] = useState(false);
  const [showReadMore, updateShowReadMore] = useState(false);

  const DemoLinkWrp = () => {
    return solutionDemo ? (
      <div>
        <Divider />
        <TextButton
          className={s.solutionDemoLink}
          dataHook="developer-name-solution-description"
          onClick={() => onDemoLinkClick(biData)}
          as="a"
          size="medium"
          target="_blank"
          href={isValidUrl(solutionDemo) ? solutionDemo : undefined}
          prefixIcon={<SiteSearch />}
        >
          {solutionDemo ? t('solution.page.demo.link') : null}
        </TextButton>{' '}
      </div>
    ) : null;
  };

  const expandToggle = () => {
    updateIsBodyExpanded(!isBodyExpanded);
  };

  const descriptionStyle =
    showReadMore && !isBodyExpanded ? s.longDescription : '';

  const DescriptionPreview = () => {
    return (
      <>
        <DescriptionPreviewWrapper description={description}>
          <Box
            maxHeight={!isBodyExpanded ? '250px' : '100%'}
            marginBottom={!showReadMore ? '24px' : '0px'}
            overflow={!isBodyExpanded ? 'hidden' : 'none'}
          >
            <div className={descriptionStyle}>
              <Text
                weight="thin"
                dataHook="solution-description"
                className="text-description"
              >
                {description}
              </Text>
              {!isBodyExpanded && (
                <VisibilityDetector
                  onHidden={() => updateShowReadMore(true)}
                  onVisible={() => {
                    updateShowReadMore(false);
                  }}
                >
                  <div></div>
                </VisibilityDetector>
              )}
            </div>
          </Box>
        </DescriptionPreviewWrapper>
        {showReadMore && (
          <TextButton
            className={s.readMoreBtn}
            size="medium"
            onClick={expandToggle}
          >
            {isBodyExpanded
              ? t('solution.page.review.readLess')
              : t('solution.page.review.readMore')}
          </TextButton>
        )}
      </>
    );
  };

  return (
    <Card className={s.descriptionContent}>
      <Heading
        appearance="H2"
        className={s.descriptionHeader}
        dataHook="solution-name"
      >
        {t('solution.page.solutionOverView', {
          name,
        })}
      </Heading>
      <Box
        direction="vertical"
        align="left"
        className={s.descriptionBenefitsContainer}
      >
        <DescriptionBenefits benefits={benefits} appId={appId} />
      </Box>
      <DescriptionPreview />
      <DemoLinkPreviewWrapper src={solutionDemo}>
        <DemoLinkWrp />
      </DemoLinkPreviewWrapper>
    </Card>
  );
};
const onDemoLinkClick = (biData: IOverViewProps) => {
  // @ts-expect-error
  biLogger.report(appMarketDemoLinkClicked(biData));
};

export default SolutionDescription;
